import { stringify } from "qs";

import consumerApi from "api/services/consumer-api";
import { Coordinates } from "custom-types/Coordinates";
import { ApiResponse, Deal } from "custom-types/Deals";
import logError from "utils/logError";

const getFeaturedDeals = async (
  coordinates: Coordinates,
  countryCode = "US",
  take = 7,
): Promise<{
  deals: Deal[];
}> => {
  const route = "/api/menu_deals/v1/featured";

  let params = {
    ...coordinates,
  };

  if (take) {
    params = { ...params, ...{ take } };
  }

  const body = stringify(params, {
    arrayFormat: "brackets",
    encodeValuesOnly: true,
  });

  try {
    const {
      data: { data = [] },
    } = await consumerApi.get<ApiResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode,
      },
    });

    return {
      deals: data,
    };
  } catch (e) {
    logError(e.message, {
      functionName: "getFeaturedDeals",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return { deals: [] };
  }
};

export default getFeaturedDeals;
